import vmClient from 'app/services/vmClient';
import { Entity, IEntityType, IEntity, EntityStringId } from 'app/types/entity';
import { Participant, IParticipant } from 'app/constants/schemas/rtc/Participant';

export interface IRoom extends IEntity {
  attributes: {
    id: EntityStringId;
  };
  associations: {
    rtcParticipants: IParticipant[];
  };
}

export type Room = Entity<IRoom>;
// defineClass is a class factory, normally classes create a runtime variable and identifier in the type namespace.
// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Room: IEntityType<IRoom> = vmClient.defineClass({
  typeName: 'Rtc.Room',
  version: 2,
  persisted: true,

  associations: {
    rtcParticipants: {
      type: Participant,
      collection: true,
      shared: true,
    },
  },
});
